import { Component } from '@angular/core';

export interface FaqItem {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent {

  faqList: FaqItem[] = [
    {
      question: 'What type of solar system is right for my home?',
      answer: `The right system depends on your electricity usage, location,
      available rooftop space, and backup power requirements.
      SolarCiti can assess your requirements and recommend a suitable
      on-grid, off-grid, or hybrid solar system.`
    },
    {
      question: 'How much can I save with a solar system?',
      answer: `Your savings depend on factors such as electricity consumption,
      system capacity, sunlight availability, tariff rates, and the type of
      solar system installed. Our team can estimate your potential savings
      based on your electricity usage.`
    },
    {
      question: 'Do you provide solar installation services?',
      answer: `Yes. SolarCiti provides end-to-end solar installation services,
      including site inspection, system design, installation, commissioning,
      and post-installation support.`
    },
    {
      question: 'Do you help with subsidy and net-metering?',
      answer: `SolarCiti can provide documentation and process support for
      applicable government solar subsidy schemes and net-metering
      requirements, subject to eligibility and applicable regulations.`
    },
    {
      question: 'What maintenance does a solar system require?',
      answer: `Regular panel cleaning, inspection, and preventive maintenance
      help keep a solar system operating efficiently. SolarCiti can provide
      maintenance and support services based on your system requirements.`
    },
    {
      question: 'Can solar panels work during cloudy weather?',
      answer: `Yes. Solar panels can still generate electricity during cloudy
      weather, although their output may be lower than on bright sunny days.
      Actual generation depends on sunlight conditions and system design.`
    }
  ];
}
